module.exports = __webpack_public_path__ + "media/images/landing/dot_pattern_bg-8a41fca496bd0608b872dfe492c5a0d5.png";